import { all } from 'redux-saga/effects';
import guardianSagas from 'guardian/reducers/sagas';

export default function* rootSaga() {
  yield all([guardianSagas()]);
}
